import { useState, useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

// @Utility
import { getStorage } from "./../../../../../../../@utility/app/storage";

// CSS
import modalStyles from "./../../../../assets/css/Modal.module.css";

// Component
import FormDeposit from './FormDeposit';
// import FormAuto from './FormAuto';
// import FormAutoTwo from './FormAutoTwo';
import FormPayment from './FormPayment';
import FormCrypto from './FormCrypto';

// 📍 Import FormP2P จากโฟลเดอร์ที่ระบุ
import FormP2P from '../form-p2p';

import SnackbarSet from "./../../../../components/SnackbarSet";
import BackButton from "./../../../../components/BackButton";

const DepositFormApp = ({ depositItems, iosPreviewUrl, setIosPreviewUrl }) => {
    const childRef = useRef();
    const [typePage, setTypePage] = useState("");
    const [bankList, setBankList] = useState(null);
    const { type } = useParams();
    const history = useHistory();
    const [selectBank, setSelectBank] = useState(0);
    const dataBankCustomerList = useSelector(state => state.reduxDeposit.dataBank);
    const [channelInfo, setChannelInfo] = useState(null);
    const dataSetting = useSelector(state => state.reduxAppMenu.menu_items);

    const renderFormDeposit = () => {
        if (type === "bank") {
            return (
                <FormDeposit iosPreviewUrl={iosPreviewUrl} setIosPreviewUrl={setIosPreviewUrl} typePage={typePage} bankList={bankList} depositItems={depositItems} selectBank={selectBank} setSelectBank={setSelectBank} channelInfo={channelInfo}></FormDeposit>
            );
        }

        if (type === "crypto") {
            return (
                <FormCrypto iosPreviewUrl={iosPreviewUrl} setIosPreviewUrl={setIosPreviewUrl} typePage={typePage} bankList={bankList} depositItems={depositItems} selectBank={selectBank} channelInfo={channelInfo} dataSetting={dataSetting}></FormCrypto>
            );
        }

        // 📍 เพิ่มเงื่อนไขสำหรับแสดง FormP2P เมื่อ type เป็น p2p
        if (type === "p2p") {
            return (
                <FormP2P 
                    iosPreviewUrl={iosPreviewUrl} 
                    setIosPreviewUrl={setIosPreviewUrl} 
                    typePage={typePage} 
                    bankList={bankList} 
                    depositItems={depositItems} 
                    selectBank={selectBank} 
                    setSelectBank={setSelectBank} 
                    channelInfo={channelInfo} 
                    dataSetting={dataSetting}
                />
            );
        }

        return (
            <FormPayment iosPreviewUrl={iosPreviewUrl} setIosPreviewUrl={setIosPreviewUrl} typePage={typePage} bankList={bankList} depositItems={depositItems} selectBank={selectBank} channelInfo={channelInfo}></FormPayment>
        );
    };

    useEffect(() => {
        if (depositItems.mode === "deposit") {
            if (dataBankCustomerList !== null) {
                let dataRes = dataBankCustomerList;
                let dataFilter = [];

                if (type === "bank") {
                    if (dataRes.length > 0) {
                        if (dataRes.length > 1) {
                            setBankList(dataRes);
                        }
                        else {
                            setBankList(dataRes);
                            setSelectBank(dataRes[0].id);
                        }
                    }
                    else {
                        setBankList([]);
                        setSelectBank(0);
                    }
                }
                else {
                    if (type === "truemoney") {
                        dataFilter = dataRes.filter((item) => (item.swift_code === "TRUEMONEY"));
                    }
                    else {
                        dataFilter = dataRes.filter((item) => (item.swift_code !== "TRUEMONEY"));
                    }

                    if (dataFilter.length > 0) {
                        setBankList(dataFilter);
                        setSelectBank(dataFilter[0].id);
                    }
                    else {
                        setBankList([]);
                        setSelectBank(0);
                    }
                }
            }
        }
        else {
            setBankList(null);
            setSelectBank(0);
        }
    }, [dataBankCustomerList, depositItems.mode, type]); // 📍 แอบเติม dependency ให้ useEffect สมบูรณ์ขึ้นเล็กน้อย

    // test
    useEffect(() => {
        setTypePage(type);
    }, [type]);

    useEffect(() => {
        if (depositItems && typePage) {
            if (depositItems?.mode !== "pay" && depositItems?.mode !== "withdraw") {
                const getChannelAll = depositItems?.channel;

                if (getChannelAll) {
                    const findChannel = getChannelAll.find((item) => item.key === typePage);

                    if (findChannel) {
                        setChannelInfo(findChannel);
                    }

                    if (!findChannel) {
                        history.push("/deposit/home");
                    }
                }
            }

            if (depositItems?.mode === "pay" && !channelInfo) {
                const getChannelAll = depositItems?.channel;

                if (getChannelAll) {
                    const findChannel = getChannelAll.find((item) => item.key === typePage);

                    if (findChannel) {
                        setChannelInfo(findChannel);
                    }

                    if (!findChannel) {
                        let channelPaySelect = null;

                        try {
                            channelPaySelect = JSON.parse(getStorage("channelPaySelect"));
                        } catch (error) {
                            channelPaySelect = null;
                        }

                        if (channelPaySelect) {
                            setChannelInfo(channelPaySelect);
                        } else {
                            history.push("/deposit/home");
                        }
                    }
                }
            }
        }
    }, [depositItems, typePage, channelInfo, history]);

    return (
        <>
            <SnackbarSet ref={childRef} />
            <div className={modalStyles.backButtonFull} onClick={() => { history.push("/deposit/home") }}>
                {
                    depositItems !== null && (
                        depositItems.mode !== "pay" && (
                            (depositItems?.channel?.automatic !== false || depositItems?.channel?.truemoney !== false) && (
                                <BackButton></BackButton>
                            )
                        )
                    )
                }
            </div>
            <div id="DepositApp">
                {
                    renderFormDeposit()
                }
            </div>
        </>
    );
}

export default DepositFormApp;